import type { ReactNode } from "react";

import { RoundedBox, Typography } from "@braintrust/braintrust-ui-components";
import { PendingFreelancerActionButton } from "@js/apps/freelancer/components/pending-freelancer-action-button";
import { useUserNeedsIdentityVerification } from "@js/apps/identity-verification";

import { useIsScreeningAvailable } from "../../hooks/use-is-screening-available";

export const PendingActionCard = () => {
  const { userNeedsIdentityVerification } = useUserNeedsIdentityVerification();
  const { isScreeningAvailable } = useIsScreeningAvailable();

  if (userNeedsIdentityVerification) {
    return (
      <PendingActionCardBase
        color="violet"
        title="Verify your identity!"
        content={
          "Only applications from individuals who have been verified are shown to clients, so it's essential to complete your identity verification to land a job on Braintrust."
        }
      />
    );
  }

  if (isScreeningAvailable) {
    return (
      <PendingActionCardBase
        color="green"
        title="Start your screening!"
        content={
          "Only applications from individuals who have been approved as Talent are shown to clients, so it's essential to complete your screening to land a job on Braintrust."
        }
      />
    );
  }

  return null;
};

type PendingActionCardBaseProps = {
  title: string;
  content: ReactNode;
  color: "green" | "violet";
};

const PendingActionCardBase = ({
  title,
  content,
  color,
}: PendingActionCardBaseProps) => {
  return (
    <RoundedBox sx={{ bgcolor: `var(--medium-${color})` }}>
      <Typography component="p" variant="paragraph" size="large" sx={{ mb: 2 }}>
        {title}
      </Typography>
      <Typography component="p" variant="paragraph">
        {content}
      </Typography>
      <PendingFreelancerActionButton
        variant="primary"
        sx={{ mt: 2 }}
        withIcon
      />
    </RoundedBox>
  );
};
